import { useSyncExternalStore } from 'react';

/**
 * Глобальный стор бан-гейта (по образцу maintenance.ts): любой 403
 * `{ banned: true }` от API переключает приложение на BannedScreen.
 * Флаг персональный, анонимного эндпоинта для «off» нет — сбрасывается
 * только перезагрузкой (кнопка «Обновить» на экране).
 */
type GateState = { banned: boolean; message: string | null };

let state: GateState = { banned: false, message: null };
const listeners = new Set<() => void>();

export function setBanned(banned: boolean, message: string | null): void {
  if (state.banned === banned && state.message === message) return;
  state = { banned, message };
  listeners.forEach((l) => l());
}

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}

function getSnapshot(): GateState {
  return state;
}

export function useGate(): GateState {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}

/**
 * 401 после старта (протухший 7-дневный токен): клиент дёргает
 * зарегистрированный AuthProvider'ом обработчик — в Telegram это тихий
 * re-auth по initData, в браузере возврат на экран входа. Раньше юзер
 * застревал на пер-экранном ErrorView с мёртвым токеном.
 */
let unauthorizedHandler: (() => void) | null = null;

export function setOnUnauthorized(handler: (() => void) | null): void {
  unauthorizedHandler = handler;
}

export function fireUnauthorized(): void {
  unauthorizedHandler?.();
}
